import { PositionSchema } from '@thinkalpha/ui-types/types/position';
import { createRemoteSlice, createRemoteSliceConfig } from 'src/store/lib/createRemoteSlice';
import z from 'zod';

export const workspaceSettings = createRemoteSliceConfig({
    name: 'workspaceSettings',
    state: z.object({
        showMenu: z.boolean(),
        buttonPosition: PositionSchema,
    }),
    actions: {
        showMenu: z.void(),
        hideMenu: z.void(),
        setButtonPosition: PositionSchema,
    },
});

export const workspaceSettingsSlice = /*#__PURE__*/ createRemoteSlice({
    config: workspaceSettings,
    initialState: {
        showMenu: false,
        buttonPosition: {
            type: 'offScreen',
        },
    },
    reducers: {
        showMenu(state) {
            return {
                ...state,
                showMenu: true,
            };
        },
        hideMenu(state) {
            return {
                ...state,
                showMenu: false,
            };
        },
        setButtonPosition(state, action) {
            return {
                ...state,
                buttonPosition: action.payload,
            };
        },
    },
});
